import React, { Component } from "react";
import PropTypes from "prop-types";

class AccessDenied extends Component {
	render() {
		return (
			<div className="access-denied">
				<div className="absolute-center ta-center">
					<div className="access-denied-icon">
						<i className="fal fa-ban"></i>
					</div>
					<div className="access-denied-text">{"Doesn't look like you should be here"}</div>
					<a href="/apps">
						<div className="btn btn-primary m-top">Take me back home</div>
					</a>
				</div>
			</div>
		);
	}
}

AccessDenied.propTypes = {
	auth: PropTypes.object,
	controlPanel: PropTypes.object,
	apps: PropTypes.object,
	user: PropTypes.object,
	location: PropTypes.object,
	controlPanelActions: PropTypes.object,
};
export default AccessDenied;
